module.exports = __webpack_public_path__ + "assets/images/share.svg";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/share.svg
// module id = 498
// module chunks = 0